module.exports = __webpack_public_path__ + "img/ikybs.3f88fe10.png";